import { useEffect as e } from "react";
//#region src/hooks/useKeyboardShortcut.ts
var t = () => {
	if (typeof navigator > "u") return !1;
	let e = `${navigator.platform || ""} ${navigator.userAgent || ""}`;
	return /mac|iphone|ipad|ipod/i.test(e);
}, n = (e, t, n) => {
	let r = t.toLowerCase().split("+").map((e) => e.trim()).filter(Boolean);
	if (r.length === 0) return !1;
	let i = r[r.length - 1], a = new Set(r.slice(0, -1)), o = a.has("mod"), s = a.has("ctrl") || o && !n, c = a.has("meta") || a.has("cmd") || o && n, l = a.has("shift"), u = a.has("alt") || a.has("option");
	return !(e.key.toLowerCase() !== i || s !== e.ctrlKey || c !== e.metaKey || l !== e.shiftKey || u !== e.altKey);
}, r = (r, i, a = {}) => {
	let { enabled: o = !0, preventDefault: s = !0, target: c } = a, l = Array.isArray(r) ? r : [r];
	e(() => {
		if (!o) return;
		let e = c ?? (typeof window < "u" ? window : null);
		if (!e) return;
		let r = t(), a = (e) => {
			let t = e;
			l.some((e) => n(t, e, r)) && (s && t.preventDefault(), i(t));
		};
		return e.addEventListener("keydown", a), () => e.removeEventListener("keydown", a);
	}, [
		l.join("|"),
		i,
		o,
		s,
		c
	]);
};
//#endregion
export { r as useKeyboardShortcut };
